<template>
    <div class="ah-page company-info-setting">
        <div class="page-header bottom-margin">
            <div class="ah-container">
                <div class="title-row">
                    <div class="title">
                        <h1>公司資訊設定</h1>
                    </div>
                    <div class="actions"></div>
                </div>
            </div>
        </div>
        <div class="ah-container">
            <el-form ref="form" :model="form" :rules="rules" label-width="180px" label-position="right">
                <div class="ah-panel">
                    <div class="panel-header small gray">
                        <div class="panel-title">公司資訊</div>
                    </div>
                    <div class="panel-body">
                        <el-form-item label="統一編號" prop="bsn">
                            <el-input v-model="form.bsn" placeholder="" :maxlength="8" :show-word-limit="true" disabled></el-input>
                        </el-form-item>
                        <el-form-item label="中文">
                            <el-input v-model="form.cH_CMP" placeholder="" :maxlength="50" :show-word-limit="true"></el-input>
                        </el-form-item>
                        <el-form-item label="英文">
                            <el-input v-model="form.eN_CMP" placeholder="" :maxlength="100" :show-word-limit="true"></el-input>
                        </el-form-item>
                        <el-form-item label="地址 (中文)">
                            <el-input v-model="form.cH_ADR" placeholder="" :maxlength="50" :show-word-limit="true"></el-input>
                        </el-form-item>
                        <el-form-item label="地址 (英文)">
                            <el-input v-model="form.eN_ADR" type="textarea" class="eng-addr-tb" :maxlength="200" :show-word-limit="true"></el-input>
                        </el-form-item>
                        <el-form-item label="電話">
                            <el-input v-model="form.tel" placeholder="" :maxlength="20" :show-word-limit="true"></el-input>
                        </el-form-item>
                        <el-form-item label="E-mail">
                            <el-input v-model="form.email" placeholder="" :maxlength="50" :show-word-limit="true"></el-input>
                        </el-form-item>
                        <el-form-item label="傳真">
                            <el-input v-model="form.fax" placeholder="" :maxlength="20" :show-word-limit="true"></el-input>
                        </el-form-item>
                        <el-form-item label="主題色" v-if="false">
                            <span v-on:click="colorPickerClick">
                                <el-color-picker v-model="form.color"></el-color-picker>
                            </span>
                        </el-form-item>
                        <el-form-item label="LOGO 圖示">
                            <el-upload
                                class="ah-img-upload-rect"
                                action="https://api.sokuji.tw/api/v1/Tool/UploadImg"
                                :data="{ uploadType: 1 }"
                                :headers="headers"
                                :show-file-list="false"
                                :on-success="handleAvatarSuccess"
                                :before-upload="beforeAvatarUpload"
                            >
                                <div v-if="form.logo" class="upload-display change">
                                    <img :src="form.logo" class="uploaded-img" alt="" />
                                    <div class="hint">更換檔案</div>
                                </div>
                                <div v-else class="upload-display">
                                    <div class="text">上傳檔案</div>
                                </div>
                            </el-upload>
                        </el-form-item>
                        <el-form-item label="員工人數">
                            <MoneyInput v-model="form.cmP_CNT" placeholder="" style="width: 150px" suffix="人"></MoneyInput>
                        </el-form-item>
                        <el-form-item label="公司登記日">
                            <el-date-picker v-model="form.rdt" :clearable="false" placeholder="" format="yyyy-MM-dd" value-format="timestamp"></el-date-picker>
                        </el-form-item>
                        <el-form-item label="變更登記日">
                            <el-date-picker v-model="form.bdt" :clearable="false" placeholder="" format="yyyy-MM-dd" value-format="timestamp"></el-date-picker>
                        </el-form-item>
                        <el-form-item label="登記資本額">
                            <MoneyInput v-model="form.amt" placeholder=""></MoneyInput>
                        </el-form-item>
                        <el-form-item label="實收資本額">
                            <MoneyInput v-model="form.ramt" placeholder=""></MoneyInput>
                        </el-form-item>
                        <el-form-item label="負責人" prop="bos">
                            <el-input v-model="form.bos" placeholder="" :maxlength="50" :show-word-limit="true"></el-input>
                        </el-form-item>
                        <el-form-item label="連絡人" prop="cnr">
                            <el-input v-model="form.cnr" placeholder="" :maxlength="50" :show-word-limit="true"></el-input>
                        </el-form-item>
                        <el-form-item label="連絡人手機" prop="cnR_TEL">
                            <el-input v-model="form.cnR_TEL" placeholder="" :maxlength="20" :show-word-limit="true"></el-input>
                        </el-form-item>
                        <el-form-item label="連絡人E-mail" prop="cnR_EML">
                            <el-input v-model="form.cnR_EML" placeholder="" :maxlength="100" :show-word-limit="true"></el-input>
                        </el-form-item>
                        <el-form-item>
                            <template slot="label">請款結算日<ahTip>用於計算下一個預計付款日</ahTip></template>
                            <el-select v-model="form.payouT_CDAT" placeholder="請選擇">
                                <el-option :key="0" label="無設定" :value="null"></el-option>
                                <el-option v-for="n in 28" :key="n" :label="n + '日'" :value="n"></el-option>
                                <el-option :key="29" label="月底" :value="29"></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item>
                            <template slot="label">請款預設付款日<ahTip>用於申請請款單時的預計付款日</ahTip></template>
                            <el-select v-model="form.payouT_PDAT" placeholder="請選擇">
                                <el-option :key="0" label="無設定" :value="null"></el-option>
                                <el-option v-for="n in 28" :key="n" :label="n + '日'" :value="n"></el-option>
                                <el-option :key="29" label="月底" :value="29"></el-option>
                            </el-select>
                        </el-form-item>
                    </div>
                </div>
                <div class="ah-panel">
                    <div class="panel-header gray small">
                        <div class="panel-title">Invoice 帳戶資訊<ah-tip>用於列印 Invoice 外匯請款單</ah-tip></div>
                    </div>
                    <div class="panel-body">
                        <el-form-item label="中文戶名">
                            <el-input v-model="form.bnK_NAM" placeholder="" :maxlength="20" :show-word-limit="true"></el-input>
                        </el-form-item>
                        <el-form-item label="英文戶名">
                            <el-input v-model="form.eN_BNK_NAM" placeholder="" :maxlength="100" :show-word-limit="true"></el-input>
                        </el-form-item>
                        <el-form-item label="銀行名稱(英文)">
                            <el-input v-model="form.eN_BNK" placeholder="" :maxlength="100" :show-word-limit="true"></el-input>
                        </el-form-item>
                        <el-form-item label="分行名稱(英文)">
                            <el-input v-model="form.eN_Branch" placeholder="" :maxlength="100" :show-word-limit="true"></el-input>
                        </el-form-item>
                        <el-form-item label="帳戶號碼">
                            <el-input v-model="form.bnK_ACC" placeholder="" :maxlength="20" :show-word-limit="true"></el-input>
                        </el-form-item>
                        <el-form-item label="SWIFT Code">
                            <el-input v-model="form.swifT_CODE" placeholder="" :maxlength="20" :show-word-limit="true"></el-input>
                        </el-form-item>
                    </div>
                </div>
                <div class="ah-panel">
                    <div class="panel-header gray small">
                        <div class="panel-title">稅籍資訊</div>
                    </div>
                    <div class="panel-body">
                        <el-form-item label="營業稅籍編號">
                            <el-input v-model="form.taX_BOO" placeholder="" :maxlength="9" :show-word-limit="true"></el-input>
                        </el-form-item>
                        <el-form-item label="扣繳所在地房屋稅籍編號">
                            <el-input v-model="form.taX_COO" placeholder="" :maxlength="20" :show-word-limit="true"></el-input>
                        </el-form-item>
                        <el-form-item label="所屬國稅局單位">
                            <el-input v-model="form.taX_PLA" placeholder="" :maxlength="30" :show-word-limit="true"></el-input>
                        </el-form-item>
                    </div>
                </div>
                <div class="ah-panel">
                    <div class="panel-header gray small">
                        <div class="panel-title">提示設定</div>
                    </div>
                    <div class="panel-body">
                        <el-form-item label="申請請款單後提示列印">
                            <el-checkbox v-model="form.isShowPrintTip"></el-checkbox>
                        </el-form-item>
                    </div>
                </div>
                <div class="ah-panel">
                    <div class="panel-header gray small">
                        <div class="panel-title">資料隱蔽性設定</div>
                    </div>
                    <div class="panel-body">
                        <el-form-item label="專案選單">
                            <el-select v-model="form.displayProject" style="min-width: 220px;">
                                <el-option :value="true" label="顯示全部資料"></el-option>
                                <el-option :value="false" label="只顯示關鍵字搜尋結果"></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="委外個人選單">
                            <el-select v-model="form.displayPersonalOutsource" style="min-width: 220px;">
                                <el-option :value="true" label="顯示全部資料"></el-option>
                                <el-option :value="false" label="只顯示關鍵字搜尋結果"></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="委外廠商選單">
                            <el-select v-model="form.displayVendorOutsource" style="min-width: 220px;">
                                <el-option :value="true" label="顯示全部資料"></el-option>
                                <el-option :value="false" label="只顯示關鍵字搜尋結果"></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="客戶選單">
                            <el-select v-model="form.displayClient" style="min-width: 220px;">
                                <el-option :value="true" label="顯示全部資料"></el-option>
                                <el-option :value="false" label="只顯示關鍵字搜尋結果"></el-option>
                            </el-select>
                        </el-form-item>
                    </div>
                </div>
                <div v-if="isEInvoicePayed" class="ah-panel">
                    <div class="panel-header gray small">
                        <div class="panel-title">電子發票串接</div>
                    </div>
                    <div class="panel-body">
                        <el-form-item label="電子發票平台">
                            <el-radio-group v-model="form.eInvoiceInfo.platform">
                                <el-radio :label="null">無</el-radio>
                                <el-radio label="EZPay">{{ eInvoicePlatformInfo.ezPay.label }}</el-radio>
                                <el-radio label="SunPay">{{ eInvoicePlatformInfo.sunPay.label }}</el-radio>
                            </el-radio-group>
                        </el-form-item>
                        <template v-if="form.eInvoiceInfo.platform">
                            <el-form-item label="商店ID" :rules="eInvoiceInfoRules.merchantID">
                                <el-input v-model.trim="form.eInvoiceInfo.merchantID" />
                            </el-form-item>
                            <el-form-item label="Hash Key" :rules="eInvoiceInfoRules.hashKey">
                                <el-input v-model.trim="form.eInvoiceInfo.hashKey" type="textarea" :rows="4" />
                            </el-form-item>
                            <el-form-item label="Hash IV" :rules="eInvoiceInfoRules.hashIV">
                                <el-input v-model.trim="form.eInvoiceInfo.hashIV" type="textarea" :rows="4" />
                            </el-form-item>
                        </template>
                    </div>
                </div>
                <div v-if="isAuth('G06')" class="ah-panel">
                    <div class="panel-header gray small">
                        <div class="panel-title">會計功能</div>
                    </div>
                    <div class="panel-body">
                        <el-form-item :label="`自動傳票功能切換：${isAutoVoucherOn ? '開啟' : '關閉'}`">
                            <el-button @click="onSwitchAutoVoucher"> 切換 </el-button>
                        </el-form-item>
                        <el-form-item>
                            <template slot="label">薪資支出會計立帳日期</template>
                            <el-select v-model="form.salaryAccountDate" placeholder="請選擇">
                                <el-option :key="0" label="月底" :value="0"></el-option>
                                <el-option v-for="n in 28" :key="n" :label="n + '日'" :value="n"></el-option>
                            </el-select>
                        </el-form-item>
                    </div>
                </div>
                <div class="ah-panel">
                    <div class="panel-header gray small">
                        <div class="panel-title">資料匯出</div>
                    </div>
                    <div class="panel-body">
                        <template v-if="form.exP_FLG === 1">
                            <el-form-item label="客戶資料">
                                <el-button @click="onExportClientData" icon="el-icon-download"> 下載 Excel </el-button>
                                <el-button @click="clientImportVisible = true" icon="el-icon-upload2" style="margin-left: 10px"> 批次匯入</el-button>
                            </el-form-item>
                            <el-form-item label="委外廠商資料">
                                <el-button @click="onExportOutsourceCompanyData" icon="el-icon-download"> 下載 Excel</el-button>
                                <el-button @click="vendorImportVisible = true" icon="el-icon-upload2" style="margin-left: 10px"> 批次匯入</el-button>
                            </el-form-item>
                            <el-form-item label="委外勞務資料">
                                <el-button @click="onExportOutsourceLaborData" icon="el-icon-download"> 下載 Excel </el-button>
                                <el-button @click="personImportVisible = true" icon="el-icon-upload2" style="margin-left: 10px"> 批次匯入</el-button>
                            </el-form-item>
                        </template>
                        <template v-else>
                            <el-alert type="info" :closable="false" show-icon>
                                <template slot="title">尚未開啟資料匯出功能，請依以下步驟申請：</template>
                                <ol style="margin: 4px 0 0; padding-left: 20px; line-height: 2;">
                                    <li>下載 <a href="/download/資料匯出申請暨責任承擔切結書.pdf" download style="color: #409EFF;">資料匯出申請暨責任承擔切結書</a>，列印並完成簽署。</li>
                                    <li>將簽署完成之切結書掃描或拍照，寄送至 service@charismatw.com。</li>
                                    <li>經確認後將由專人為您開啟此功能。</li>
                                </ol>
                            </el-alert>
                        </template>
                    </div>
                </div>
            </el-form>
        </div>
        <center>
            <el-button type="primary" class="primary-action" :loading="isSaving" @click="submitForm"> 儲存 </el-button>
        </center>
        <OutsourcingVendorImportDialog :visible="vendorImportVisible" @close="vendorImportVisible = false" />
        <OutsourcingPersonImportDialog :visible="personImportVisible" @close="personImportVisible = false" />
        <VendorNewImportDialog :visible="clientImportVisible" @close="clientImportVisible = false" />
    </div>
</template>
<script>
import ahTip from '@/components/ui/ahTip.vue';
import { eInvoicePlatformInfo } from '@/assets/commonData/options';
import { isGuiNumberValid } from 'taiwan-id-validator';
import { checkFileSize, checkFilePictureType } from '@/utils/fileValidator';
import ExcelJS from 'exceljs';
import OutsourcingVendorImportDialog from '@/components/dashboard/Outsourcing/OutsourcingVendorImportDialog.vue';
import OutsourcingPersonImportDialog from '@/components/dashboard/Outsourcing/OutsourcingPersonImportDialog.vue';
import VendorNewImportDialog from '@/components/dashboard/Vendor/VendorNewImportDialog.vue';

export default {
    components: { ahTip, OutsourcingVendorImportDialog, OutsourcingPersonImportDialog, VendorNewImportDialog },
    data() {
        const validateBsn = (rule, value, callback) => {
            if (value === '') {
                callback(new Error('請輸入統一編號。'));
            } else if (!isGuiNumberValid(value, true)) {
                callback(new Error('統一編號格式不正確'));
            } else {
                callback();
            }
        };
        return {
            isSaving: false,
            headers: {
                Authorization: `Bearer ${localStorage.getItem('token')}`,
            },
            activeTab: 'company',
            form: {
                sno: null,
                cH_CMP: '',
                cH_ADR: '',
                eN_CMP: '',
                eN_ADR: '',
                eN_BNK: '',
                eN_Branch: '',
                exP_FLG: 0, // 資料匯出功能 1:已開啟 0:未開啟
                tel: '',
                fax: '',
                email: '',
                bnK_BOO: null,
                bnK_DOO: null,
                bnK_ACC: null,
                bnK_NAM: null,
                eN_BNK_NAM: null,
                swifT_CODE: null,
                logo: '',
                color: '',
                payouT_CDAT: null,
                payouT_PDAT: null,

                bsn: '' /* 統一編號 */,
                cmP_CNT: '' /* 員工人數 */,
                rdt: '' /* 公司登記日 */,
                bdt: '' /* 變更登記日 */,
                amt: '' /* 登記資本額 */,
                ramt: '' /* 實收資本額 */,
                bos: '' /* 負責人 */,
                cnr: '' /* 連絡人 */,
                cnR_TEL: '' /* 連絡人手機 */,
                cnR_EML: '' /* 連絡人e-mail */,
                taX_BOO: '' /* 稅籍編號 */,
                taX_COO: '' /* 扣繳所在地房屋稅籍編號 */,
                taX_PLA: '' /* 所屬國稅局單位 */,

                isShowPrintTip: false,
                displayProject: null,
                displayPersonalOutsource: null,
                displayVendorOutsource: null,
                displayClient: null,

                eInvoiceInfo: {
                    onf: null,
                    sno: null,
                    platform: null,
                    merchantID: null,
                    hashKey: null,
                    hashIV: null,
                },
                salaryAccountDate: 0,
            },
            rules: {
                bsn: [{ validator: validateBsn, trigger: 'blur' }],
            },
            bankList: [],
            branchList: [],
            eInvoicePlatformInfo,
            isAutoVoucherOn: false,
            vendorImportVisible: false,
            personImportVisible: false,
            clientImportVisible: false,
        };
    },
    computed: {
        eInvoiceInfoRules() {
            if (!this.form.eInvoiceInfo.platform) {
                return {
                    merchantID: [],
                    hashKey: [],
                    hashIV: [],
                };
            }

            return {
                merchantID: [{ required: true, message: '請輸入商店ID' }],
                hashKey: [{ required: true, message: '請輸入Hash Key' }],
                hashIV: [{ required: true, message: '請輸入Hash IV' }],
            };
        },
        isEInvoicePayed() {
            return this.$store.getters['menu/companyInfo'].addeinvoice;
        },
    },
    mounted() {
        // 取得銀行下拉選單
        this.$api({
            url: '/Tool/GetBankOptions',
            method: 'GET',
        }).then((resp) => {
            this.bankList = resp.data.options;
        });

        this.$api({
            url: '/CompanyInfoManagentPage/GetCompanyInfo',
            method: 'GET',
        }).then((resp) => {
            this.form = resp.data.item;
            this.isAutoVoucherOn = resp.data.item.isAutoVoucherOn;

            if (this.isEInvoicePayed) {
                this.form.eInvoiceInfo = {
                    onf: resp.data.item.eInvoiceInfo?.onf || null,
                    sno: resp.data.item.eInvoiceInfo?.sno || null,
                    platform: resp.data.item.eInvoiceInfo?.platform || null,
                    merchantID: resp.data.item.eInvoiceInfo?.merchantID || null,
                    hashKey: resp.data.item.eInvoiceInfo?.hashKey || null,
                    hashIV: resp.data.item.eInvoiceInfo?.hashIV || null,
                };
            }

            console.log(resp.data.item);
            this.fetchBranchList(this.form.bnK_BOO, false);
        });
    },
    methods: {
        async onSwitchAutoVoucher() {
            try {
                await this.$api({
                    url: '/CompanyInfoManagentPage/SwitchAutoVoucher',
                    method: 'POST',
                    data: { IsAutoVoucherOn: !this.isAutoVoucherOn },
                });
                this.isAutoVoucherOn = !this.isAutoVoucherOn;
                this.$message({
                    showClose: true,
                    message: `已${this.isAutoVoucherOn ? '開啟' : '關閉'}自動傳票功能`,
                    type: 'success',
                });
            } catch (e) {
                this.$message({
                    showClose: true,
                    message: '切換失敗，請重試。',
                    type: 'error',
                });
                console.log(e);
            }
        },
        submitForm() {
            this.$refs.form.validate(async (valid) => {
                if (valid) {
                    this.isSaving = true;

                    // 是否啟用電子發票功能，依照平台選擇決定
                    if (this.form.eInvoiceInfo) this.form.eInvoiceInfo.onf = !!this.form.eInvoiceInfo?.platform;

                    try {
                        await this.$api({
                            url: '/CompanyInfoManagentPage/UpdateCompanyInfo',
                            method: 'POST',
                            data: {
                                ...this.form,
                                eInvoiceInfo: this.form.eInvoiceInfo?.platform ? this.form.eInvoiceInfo : null,
                            },
                        }).then(() => {
                            this.$store.dispatch('menu/updateMenu');
                            this.$message({
                                showClose: true,
                                message: '公司資訊已儲存',
                                type: 'success',
                            });
                        });
                    } finally {
                        this.isSaving = false;
                    }
                }
            });
        },
        fetchBranchList(value, refresh = true) {
            if (refresh) this.form.bnK_DOO = '';
            this.$api({
                url: `/Tool/GetBranchOptions?BOO=${value}`,
                method: 'get',
            }).then((resp) => {
                this.branchList = resp.data.options;
            });
        },
        handleAvatarSuccess(res) {
            this.form.logo = res.imgUrl;
        },
        beforeAvatarUpload(file) {
            const fileSizeErrMsg = checkFileSize(file.size);
            if (fileSizeErrMsg) {
                this.$message({
                    showClose: true,
                    message: fileSizeErrMsg,
                    type: 'error',
                });
                return false;
            }

            const fileTypeErrMsg = checkFilePictureType(file.type);
            if (fileTypeErrMsg) {
                this.$message({
                    showClose: true,
                    message: fileTypeErrMsg,
                    type: 'error',
                });
                return false;
            }
            return true;
        },
        colorPickerClick() {
            setTimeout(() => {
                const buttons = document.querySelectorAll('.el-button.el-color-dropdown__btn.el-button--default.el-button--mini.is-plain > span');

                buttons[0].innerHTML = '確定';
            }, 10);
        },

        // 匯出客戶資料
        async onExportClientData() {
            const PAGE_SIZE = 999;
            let pageNum = 1;
            let items = [];

            while (true) {
                const resp = await this.$api({
                    url: 'CompanyInfoManagentPage/GetVenderList',
                    method: 'GET',
                    params: { PageSize: PAGE_SIZE, PageNum: pageNum },
                });
                const pageItems = resp.data.items;
                items = items.concat(pageItems);
                if (pageItems.length < PAGE_SIZE) break;
                pageNum++;
            }

            const MAX_CONTACTS = 3;

            // 欄位佈局，含必填標記與註解
            const columns = [
                { header: '系統編號',       key: 'voo',                width: 14, section: 'basic', hint: '新增時不需填寫' },
                { header: '客戶全名',       key: 'fnam',               width: 40, section: 'basic', required: true },
                { header: '統一編號',       key: 'bsn',                width: 14, section: 'basic', text: true },
                { header: '聯絡地址',       key: 'adr',                width: 50, section: 'basic' },
                { header: '結帳日',         key: 'bilL_DAY',           width: 10, section: 'basic', hint: '填數字，如：1' },
                { header: '付款日',         key: 'soO_DAY',            width: 10, section: 'basic', hint: '填數字，如：1' },
                { header: '匯款帳號後五碼', key: 'accountLast5Number', width: 16, section: 'basic', text: true },
                { header: '備註',           key: 'note',               width: 40, section: 'basic' },
            ];

            for (let n = 1; n <= MAX_CONTACTS; n++) {
                columns.push(
                    { header: `聯絡窗口${n}_姓名`,  key: `c${n}_nam`, width: 16, section: 'contact' },
                    { header: `聯絡窗口${n}_稱謂`,  key: `c${n}_gen`, width: 12, section: 'contact', hint: '先生/小姐' },
                    { header: `聯絡窗口${n}_職稱`,  key: `c${n}_job`, width: 16, section: 'contact' },
                    { header: `聯絡窗口${n}_電話`,  key: `c${n}_tel`, width: 16, section: 'contact', text: true },
                    { header: `聯絡窗口${n}_分機`,  key: `c${n}_ext`, width: 10, section: 'contact', text: true },
                    { header: `聯絡窗口${n}_Email`, key: `c${n}_eml`, width: 26, section: 'contact' },
                );
            }

            const workbook = new ExcelJS.Workbook();
            const worksheet = workbook.addWorksheet('import');
            worksheet.columns = columns.map(col => ({ header: col.header, key: col.key, width: col.width }));

            // 覆寫標題列：加上 * 必填前綴和換行註解
            const exportHeaderRow = worksheet.getRow(1);
            columns.forEach((col, idx) => {
                const cell = exportHeaderRow.getCell(idx + 1);
                let text = col.required ? `*${col.header}` : col.header;
                if (col.hint) text += `\r\n(${col.hint})`;
                cell.value = text;
            });
            exportHeaderRow.height = 40;

            // 寫入資料列
            items.forEach(item => {
                const contacts = (item.vendorContacts || []).filter(c => c.nam);

                const row = {
                    voo: item.voo ?? '',
                    fnam: item.fnam ?? '',
                    bsn: item.bsn ?? '',
                    adr: item.adr ?? '',
                    bilL_DAY: item.bilL_DAY ?? '',
                    soO_DAY: item.soO_DAY ?? '',
                    accountLast5Number: item.accountLast5Number ?? '',
                    note: item.note ?? '',
                };

                for (let n = 1; n <= MAX_CONTACTS; n++) {
                    const c = contacts[n - 1];
                    row[`c${n}_nam`] = c?.nam || '';
                    row[`c${n}_gen`] = c ? (c.gen === 1 ? '小姐' : '先生') : '';
                    row[`c${n}_job`] = c?.job || '';
                    row[`c${n}_tel`] = c?.tel || '';
                    row[`c${n}_ext`] = c?.ext || '';
                    row[`c${n}_eml`] = c?.eml || '';
                }

                worksheet.addRow(row);
            });

            // 文字格式
            const textCols = columns.reduce((acc, col, idx) => { if (col.text) acc.push(idx + 1); return acc; }, []);
            worksheet.eachRow((row, rowNum) => {
                if (rowNum === 1) return;
                textCols.forEach(colNum => {
                    const cell = row.getCell(colNum);
                    if (cell.value != null && cell.value !== '') cell.numFmt = '@';
                });
            });

            // 標題列樣式：色碼 + wrapText
            const SECTION_COLORS = { basic: 'FFE2EFDA', contact: 'FFDAE8FC' };
            columns.forEach((col, idx) => {
                const cell = exportHeaderRow.getCell(idx + 1);
                cell.font = { bold: true, size: 10 };
                cell.alignment = { wrapText: true, vertical: 'top' };
                cell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: SECTION_COLORS[col.section] } };
            });

            worksheet.views = [{ state: 'frozen', ySplit: 1 }];

            const today = new Date();
            const dateStr = `${today.getFullYear()}${String(today.getMonth() + 1).padStart(2, '0')}${String(today.getDate()).padStart(2, '0')}`;
            this.downloadExcel(workbook, `客戶資料_${dateStr}.xlsx`);
        },
        
        async onExportOutsourceCompanyData() {
            // 分頁取得全部資料
            const PAGE_SIZE = 999;
            let pageNum = 1;
            let items = [];

            while (true) {
                const resp = await this.$api({
                    url: 'CompanyInfoManagentPage/GetOutsourcingVendor',
                    method: 'GET',
                    params: { VDR_TYP: 'vd', PageSize: PAGE_SIZE, PageNum: pageNum },
                });
                const pageItems = resp.data.items;
                items = items.concat(pageItems);
                if (pageItems.length < PAGE_SIZE) break;
                pageNum++;
            }

            const MAX_CONTACTS = 3;
            const MAX_BANKS = 3;

            // 欄位佈局定義，含必填標記與註解
            const columns = [
                { header: '系統編號',       key: 'voo',          width: 14, section: 'basic', hint: '新增時不需填寫' },
                { header: '類型',           key: 'caT_NAM',      width: 20, section: 'basic', required: true, hint: '必須在「委外類型」中已建立' },
                { header: '公司名稱',       key: 'fnam',         width: 40, section: 'basic', required: true },
                { header: '統一編號',       key: 'bsn',          width: 14, section: 'basic', text: true, hint: '營利事業必填' },
                { header: '國籍',           key: '_abd',         width: 12, section: 'basic', required: true, hint: '本國/境外' },
                { header: '境外類型',       key: '_abD_TYP',     width: 14, section: 'basic', hint: '境外必填\n政府/公營事業/民間' },
                { header: '營利類型',       key: '_profitType',   width: 16, section: 'basic', required: true, hint: '營利事業/非營利事業' },
                { header: '縣市／國家',     key: '_cityOrArea',   width: 16, section: 'basic' },
                { header: '地址',           key: 'adr',          width: 40, section: 'basic' },
                { header: '郵遞區號',       key: 'adR_CODE',     width: 10, section: 'basic', text: true },
                { header: '備註',           key: 'note',         width: 40, section: 'basic' },
            ];

            for (let n = 1; n <= MAX_CONTACTS; n++) {
                columns.push(
                    { header: `聯絡窗口${n}_姓名`,  key: `c${n}_nam`, width: 16, section: 'contact' },
                    { header: `聯絡窗口${n}_稱謂`,  key: `c${n}_gen`, width: 12, section: 'contact', hint: '先生/小姐' },
                    { header: `聯絡窗口${n}_職稱`,  key: `c${n}_job`, width: 16, section: 'contact' },
                    { header: `聯絡窗口${n}_電話`,  key: `c${n}_tel`, width: 16, section: 'contact', text: true },
                    { header: `聯絡窗口${n}_分機`,  key: `c${n}_ext`, width: 10, section: 'contact', text: true },
                    { header: `聯絡窗口${n}_Email`, key: `c${n}_eml`, width: 26, section: 'contact' },
                );
            }

            for (let n = 1; n <= MAX_BANKS; n++) {
                columns.push(
                    { header: `帳戶${n}_類型`,         key: `b${n}_type`,   width: 14, section: 'bank', hint: '本國帳戶/外國帳戶' },
                    { header: `帳戶${n}_戶名`,         key: `b${n}_tpc`,    width: 20, section: 'bank' },
                    { header: `帳戶${n}_銀行代號`,     key: `b${n}_boo`,    width: 14, section: 'bank', text: true, hint: '本國帳戶用，共3碼' },
                    { header: `帳戶${n}_分行代號`,     key: `b${n}_doo`,    width: 14, section: 'bank', text: true, hint: '本國帳戶用，共7碼' },
                    { header: `帳戶${n}_收款帳號`,     key: `b${n}_acc`,    width: 22, section: 'bank', text: true },
                    { header: `帳戶${n}_銀行英文名稱`, key: `b${n}_abroad`, width: 24, section: 'bank', hint: '外國帳戶必填' },
                    { header: `帳戶${n}_SWIFT Code`,   key: `b${n}_swift`,  width: 16, section: 'bank', hint: '外國帳戶必填' },
                    { header: `帳戶${n}_備註`,         key: `b${n}_note`,   width: 20, section: 'bank' },
                );
            }

            // 建立 Excel，sheet 命名為 "import" 讓匯出檔可直接回匯入
            const workbook = new ExcelJS.Workbook();
            const worksheet = workbook.addWorksheet('import');
            worksheet.columns = columns.map(col => ({ header: col.header, key: col.key, width: col.width }));

            // 覆寫標題列：加上 * 必填前綴和換行註解
            const exportHeaderRow = worksheet.getRow(1);
            columns.forEach((col, idx) => {
                const cell = exportHeaderRow.getCell(idx + 1);
                let text = col.required ? `*${col.header}` : col.header;
                if (col.hint) text += `\r\n(${col.hint})`;
                cell.value = text;
            });
            exportHeaderRow.height = 48;

            const ABD_TYP_MAP = { 0: '政府', 1: '公營事業', 2: '民間' };

            // 寫入資料列：每筆 item 只做一次 filter
            items.forEach(item => {
                const contacts = (item.vendorContacts || []).filter(c => c.onf !== 0 && c.nam);
                const banks = item.vendorBanks || [];

                const row = {
                    voo: item.voo ?? '',
                    caT_NAM: item.caT_NAM ?? '',
                    fnam: item.fnam ?? '',
                    bsn: item.bsn ?? '',
                    _abd: item.abd === 0 ? '本國' : '境外',
                    _abD_TYP: item.abd === 1 ? (ABD_TYP_MAP[item.abD_TYP] || '') : '',
                    _profitType: item.profitType === 2 ? '非營利事業' : '營利事業',
                    _cityOrArea: item.abd === 0 ? (item.cty || '') : (item.ara || ''),
                    adr: item.adr ?? '',
                    adR_CODE: item.adR_CODE ?? '',
                    note: item.note ?? '',
                };

                for (let n = 1; n <= MAX_CONTACTS; n++) {
                    const c = contacts[n - 1];
                    row[`c${n}_nam`] = c?.nam || '';
                    row[`c${n}_gen`] = c ? (c.gen === 1 ? '小姐' : '先生') : '';
                    row[`c${n}_job`] = c?.job || '';
                    row[`c${n}_tel`] = c?.tel || '';
                    row[`c${n}_ext`] = c?.ext || '';
                    row[`c${n}_eml`] = c?.eml || '';
                }

                for (let n = 1; n <= MAX_BANKS; n++) {
                    const b = banks[n - 1];
                    row[`b${n}_type`]   = b ? (b.accountType === 2 ? '外國帳戶' : '本國帳戶') : '';
                    row[`b${n}_tpc`]    = b?.bnK_TPC || '';
                    row[`b${n}_boo`]    = b?.bnK_BOO || '';
                    row[`b${n}_doo`]    = b?.bnK_DOO || '';
                    row[`b${n}_acc`]    = b?.bnK_ACC || '';
                    row[`b${n}_abroad`] = b?.abroadBankName || '';
                    row[`b${n}_swift`]  = b?.swiftCode || '';
                    row[`b${n}_note`]   = b?.note || '';
                }

                worksheet.addRow(row);
            });

            // 需要文字格式的欄位索引（防止 Excel 把統編、帳號、電話等轉為數字）
            const textCols = columns.reduce((acc, col, idx) => { if (col.text) acc.push(idx + 1); return acc; }, []);
            worksheet.eachRow((row, rowNum) => {
                if (rowNum === 1) return;
                textCols.forEach(colNum => {
                    const cell = row.getCell(colNum);
                    if (cell.value != null && cell.value !== '') cell.numFmt = '@';
                });
            });

            // 標題列樣式：色碼 + wrapText
            const SECTION_COLORS = { basic: 'FFE2EFDA', contact: 'FFDAE8FC', bank: 'FFFFF2CC' };
            columns.forEach((col, idx) => {
                const cell = exportHeaderRow.getCell(idx + 1);
                cell.font = { bold: true, size: 10 };
                cell.alignment = { wrapText: true, vertical: 'top' };
                cell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: SECTION_COLORS[col.section] } };
            });

            worksheet.views = [{ state: 'frozen', ySplit: 1 }];

            const today = new Date();
            const dateStr = `${today.getFullYear()}${String(today.getMonth() + 1).padStart(2, '0')}${String(today.getDate()).padStart(2, '0')}`;
            this.downloadExcel(workbook, `委外廠商_${dateStr}.xlsx`);
        },

        async onExportOutsourceLaborData() {
            // 分頁取得全部資料
            const PAGE_SIZE = 999;
            let pageNum = 1;
            let items = [];

            while (true) {
                const resp = await this.$api({
                    url: 'CompanyInfoManagentPage/GetOutsourcingPerson',
                    method: 'GET',
                    params: { VDR_TYP: 'os', PageSize: PAGE_SIZE, PageNum: pageNum },
                });
                const pageItems = resp.data.items;
                items = items.concat(pageItems);
                if (pageItems.length < PAGE_SIZE) break;
                pageNum++;
            }

            const MAX_BANKS = 3;
            const ABD_MAP = { 0: '本國人', 1: '外國籍（已滿183天）', 2: '外國籍（未滿183天）' };

            // 欄位佈局：基本資料（18 欄），含必填標記與註解（匯出時同步帶入，讓匯出檔可直接再匯入）
            const columns = [
                { header: '系統編號',         key: 'voo',                  width: 14, section: 'basic', hint: '新增時不需填寫' },
                { header: '類型',             key: 'caT_NAM',              width: 20, section: 'basic', required: true, hint: '必須在「委外類型」中已建立' },
                { header: '姓名',             key: 'fnam',                 width: 20, section: 'basic', required: true },
                { header: '稱謂',             key: '_gen',                 width: 10, section: 'basic', required: true, hint: '先生/小姐' },
                { header: '國籍',             key: '_abd',                 width: 30, section: 'basic', required: true, hint: '本國人/外國籍（已滿183天）/外國籍（未滿183天）' },
                { header: '證件類型',         key: '_idType',              width: 22, section: 'basic', required: true, hint: '本國：身分證/營業統一編號\n外國：護照號碼/居留證' },
                { header: '證件編號',         key: 'bsn',                  width: 16, section: 'basic', required: true, text: true },
                { header: '戶籍地區／縣市',   key: '_permanentCityOrArea', width: 16, section: 'basic' },
                { header: '戶籍地址',         key: 'permanentAddr',        width: 40, section: 'basic' },
                { header: '戶籍地址郵遞區號', key: 'permanentAdR_CODE',    width: 14, section: 'basic', text: true },
                { header: '聯絡地區／縣市',   key: '_cityOrArea',          width: 16, section: 'basic' },
                { header: '聯絡地址',         key: 'adr',                  width: 40, section: 'basic' },
                { header: '聯絡地址郵遞區號', key: 'adR_CODE',             width: 14, section: 'basic', text: true },
                { header: '投保職業工會',     key: '_oS_GRP',              width: 14, section: 'basic', required: true, hint: '有/無' },
                { header: '電話',             key: '_tel',                 width: 16, section: 'basic', text: true },
                { header: '分機',             key: '_ext',                 width: 10, section: 'basic', text: true },
                { header: 'E-mail',           key: '_eml',                 width: 30, section: 'basic' },
                { header: '備註',             key: 'note',                 width: 40, section: 'basic' },
            ];

            // 收款帳戶（最多 MAX_BANKS 筆）
            for (let n = 1; n <= MAX_BANKS; n++) {
                columns.push(
                    { header: `帳戶${n}_類型`,         key: `b${n}_type`,   width: 14, section: 'bank', hint: '本國帳戶/外國帳戶' },
                    { header: `帳戶${n}_戶名`,         key: `b${n}_tpc`,    width: 20, section: 'bank' },
                    { header: `帳戶${n}_銀行代號`,     key: `b${n}_boo`,    width: 14, section: 'bank', text: true, hint: '本國帳戶用，共3碼' },
                    { header: `帳戶${n}_分行代號`,     key: `b${n}_doo`,    width: 14, section: 'bank', text: true, hint: '本國帳戶用，共7碼' },
                    { header: `帳戶${n}_收款帳號`,     key: `b${n}_acc`,    width: 22, section: 'bank', text: true },
                    { header: `帳戶${n}_銀行英文名稱`, key: `b${n}_abroad`, width: 24, section: 'bank', hint: '外國帳戶必填' },
                    { header: `帳戶${n}_SWIFT Code`,   key: `b${n}_swift`,  width: 16, section: 'bank', hint: '外國帳戶必填' },
                    { header: `帳戶${n}_備註`,         key: `b${n}_note`,   width: 20, section: 'bank' },
                );
            }

            const workbook = new ExcelJS.Workbook();
            const worksheet = workbook.addWorksheet('import');
            worksheet.columns = columns.map(col => ({ header: col.header, key: col.key, width: col.width }));

            // 覆寫標題列：加上 * 必填前綴和換行註解
            const headerRow = worksheet.getRow(1);
            columns.forEach((col, idx) => {
                const cell = headerRow.getCell(idx + 1);
                let text = col.required ? `*${col.header}` : col.header;
                if (col.hint) text += `\r\n(${col.hint})`;
                cell.value = text;
            });
            headerRow.height = 48;

            // 寫入資料列
            items.forEach(item => {
                const contact = item.vendorContacts?.[0];
                const banks = item.vendorBanks || [];

                // 證件類型
                let idType = '';
                if (item.abd === 0) {
                    idType = item.bsN_TYP === 2 ? '營業統一編號' : '身分證';
                } else {
                    idType = item.identificationType === 2 ? '居留證' : '護照號碼';
                }

                const row = {
                    voo: item.voo ?? '',
                    caT_NAM: item.caT_NAM ?? '',
                    fnam: item.fnam ?? '',
                    _gen: contact ? (contact.gen === 1 ? '小姐' : '先生') : '',
                    _abd: ABD_MAP[item.abd] || '',
                    _idType: idType,
                    bsn: item.bsn ?? '',
                    _permanentCityOrArea: item.abd === 0 ? (item.permanentAddrCty || '') : (item.permanentAddrAra || ''),
                    permanentAddr: item.permanentAddr ?? '',
                    permanentAdR_CODE: item.permanentAdR_CODE ?? '',
                    _cityOrArea: item.abd === 0 ? (item.cty || '') : (item.ara || ''),
                    adr: item.adr ?? '',
                    adR_CODE: item.adR_CODE ?? '',
                    _oS_GRP: item.oS_GRP ? '有' : '無',
                    _tel: contact?.tel || '',
                    _ext: contact?.ext || '',
                    _eml: contact?.eml || '',
                    note: item.note ?? '',
                };

                for (let n = 1; n <= MAX_BANKS; n++) {
                    const b = banks[n - 1];
                    row[`b${n}_type`]   = b ? (b.accountType === 2 ? '外國帳戶' : '本國帳戶') : '';
                    row[`b${n}_tpc`]    = b?.bnK_TPC || '';
                    row[`b${n}_boo`]    = b?.bnK_BOO || '';
                    row[`b${n}_doo`]    = b?.bnK_DOO || '';
                    row[`b${n}_acc`]    = b?.bnK_ACC || '';
                    row[`b${n}_abroad`] = b?.abroadBankName || '';
                    row[`b${n}_swift`]  = b?.swiftCode || '';
                    row[`b${n}_note`]   = b?.note || '';
                }

                worksheet.addRow(row);
            });

            // 文字格式
            const textCols = columns.reduce((acc, col, idx) => { if (col.text) acc.push(idx + 1); return acc; }, []);
            worksheet.eachRow((row, rowNum) => {
                if (rowNum === 1) return;
                textCols.forEach(colNum => {
                    const cell = row.getCell(colNum);
                    if (cell.value != null && cell.value !== '') cell.numFmt = '@';
                });
            });

            // 標題列樣式：色碼 + wrapText（配合帶註解的多行標題）
            const SECTION_COLORS = { basic: 'FFE2EFDA', bank: 'FFFFF2CC' };
            columns.forEach((col, idx) => {
                const cell = headerRow.getCell(idx + 1);
                cell.font = { bold: true, size: 10 };
                cell.alignment = { wrapText: true, vertical: 'top' };
                cell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: SECTION_COLORS[col.section] } };
            });

            worksheet.views = [{ state: 'frozen', ySplit: 1 }];

            const today = new Date();
            const dateStr = `${today.getFullYear()}${String(today.getMonth() + 1).padStart(2, '0')}${String(today.getDate()).padStart(2, '0')}`;
            this.downloadExcel(workbook, `委外勞務_${dateStr}.xlsx`);
        },

        async downloadExcel(workbook, fileName) {
            const buffer = await workbook.xlsx.writeBuffer();
            const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
            const url = URL.createObjectURL(blob);
            const a = document.createElement('a');
            a.href = url;
            a.download = fileName;
            a.click();
            URL.revokeObjectURL(url);
        },
    },
};
</script>
<style lang="scss">
.company-info-setting {
    .el-tabs__header {
        margin-bottom: 25px;
    }

    .el-form {
        .el-form-item {
            max-width: 800px;
        }
    }

    .bank-row {
        @media (min-width: 992px) {
            width: 420px;
        }
    }

    .eng-addr-tb > .el-textarea__inner {
        font-family: unset;
        color: #222;
    }
}
</style>
